module.exports = __webpack_public_path__ + "img/www.ee3d884a.png";